import { useState } from 'react';
import classNames from 'classnames/bind';
import { isMobile, isSafari } from 'react-device-detect';

import WistiaPlayer from '../../../../Shared/WistiaPlayer';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const TopicClassesVideo = () => {
  const [activeTab, setActiveTab] = useState('isDesktop');

  const handleTabClick = (type) => {
    setActiveTab(type);
  };

  return (
    <div className={Styles['topic-classes-video']}>
      <div className={Styles['topic-classes-video-title']}>
        How To Use CityFALCON's Sentiment Scores
      </div>
      <div className={Styles['topic-classes-video-tabs']}>
        <div
          className={cx('topic-classes-video-tab', { active: activeTab === 'isDesktop' })}
          onClick={() => handleTabClick('isDesktop')}
        >
          Desktop
        </div>
        <div
          className={cx('topic-classes-video-tab', { active: activeTab === 'isMobile' })}
          onClick={() => handleTabClick('isMobile')}
        >
          Mobile
        </div>
      </div>
      <div className={Styles['topic-classes-video-holder']}>
        <div className={cx('topic-classes-video-body', { active: activeTab === 'isDesktop', is_safari: isSafari })}>
          <WistiaPlayer
            url="https://cityfalcon.wistia.com/medias/362922bfs9"
            controls
            config={{
              options: isMobile ? { playsinline: false } : {},
            }}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          />
        </div>
        <div className={cx('topic-classes-video-body', { active: activeTab === 'isMobile', is_safari: isSafari })}>
          <WistiaPlayer
            url="https://cityfalcon.wistia.com/medias/xxio1ni47b"
            controls
            config={{
              options: isMobile ? { playsinline: false } : {},
            }}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          />
        </div>
      </div>
      <div className={Styles['topic-classes-video-btn']}>
        <a
          href="/features/sentiment"
          className={Styles.button}
        >
          Learn More
        </a>
      </div>
    </div>
  );
};

export default TopicClassesVideo;
